export const FIRST_MESSAGE_ID = ['firstMessageId'];
export const GENERIC_CHANNEL_ID = ['genericChannelId'];
export const MESSAGE_ID = ['messageId'];
export const TIMESTAMP = ['timestamp'];